import React from "react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Avatar, AvatarFallback, AvatarImage } from "../../ui/avatar";
import { defaultPfpUrl } from "../../utils";

/**
 * Modal listing everyone whose last-read cursor is on a message.
 * @param {Object} props
 * @param {boolean} props.open
 * @param {(open: boolean) => void} props.onOpenChange
 * @param {Array<{ user_id: number, name?: string, pfp?: string }>} props.readers
 * @returns {JSX.Element}
 */
function ReadsModal({ open, onOpenChange, readers }) {
  const list = Array.isArray(readers) ? readers : [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm p-0">
        <DialogHeader>
          <DialogTitle>Read by</DialogTitle>
        </DialogHeader>
        <div className="max-h-72 overflow-y-auto px-2 py-2">
          {list.length === 0 ? (
            <p className="px-3 py-6 text-center text-sm text-text-muted">
              No readers yet
            </p>
          ) : (
            <ul className="space-y-1">
              {list.map((user) => (
                <li
                  key={user.user_id}
                  className="flex items-center gap-3 rounded-md px-2 py-2 hover:bg-ui-muted"
                >
                  <Link
                    to={`/profile/${user.user_id}`}
                    className="flex min-w-0 flex-1 items-center gap-3"
                    onClick={() => onOpenChange(false)}
                  >
                    <Avatar className="h-8 w-8 shrink-0">
                      <AvatarImage
                        src={user.pfp || defaultPfpUrl}
                        alt={user.name || "User"}
                        onError={(e) => {
                          e.target.src = defaultPfpUrl;
                        }}
                      />
                      <AvatarFallback>
                        {(user.name || "?").slice(0, 1).toUpperCase()}
                      </AvatarFallback>
                    </Avatar>
                    <span className="truncate text-sm text-text-primary">
                      {user.name || "User"}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ReadsModal;
